import { render, staticRenderFns } from "./googleSsoBtn.vue?vue&type=template&id=5f16043e&scoped=true"
import script from "./googleSsoBtn.vue?vue&type=script&lang=js"
export * from "./googleSsoBtn.vue?vue&type=script&lang=js"
import style0 from "./googleSsoBtn.vue?vue&type=style&index=0&id=5f16043e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f16043e",
  null
  
)

export default component.exports